import { Navigate } from 'react-router-dom';

// Redirect component for legacy hub routes without /pay
const HubRedirect = () => <Navigate to="/hub/" replace />;

export default HubRedirect;
